import { render, staticRenderFns } from "./ImageSelector.vue?vue&type=template&id=3d01d076&scoped=true&lang=pug&"
import script from "./ImageSelector.vue?vue&type=script&lang=js&"
export * from "./ImageSelector.vue?vue&type=script&lang=js&"
import style0 from "./ImageSelector.vue?vue&type=style&index=0&id=3d01d076&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d01d076",
  null
  
)

/* custom blocks */
import block0 from "@/lang/components/imageSelector.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fsrc%2Fcomponents%2FImageSelector.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports